export const useStyles = () => {
  const joinClasses = (classesArray: Array<string>) => classesArray.join(' ');

  return {
    joinClasses
  };
};
